<template>
    <div class="cart">
        <a :href="'/' + culture + '/shop/review'" onclick="return false;" rel="nofollow" v-on:click="openModal()" class="cart-summary-container2 fadeIn" id="cart-summary-container2" :class="Cart.NumberOfCartItems == undefined || Cart.NumberOfCartItems == 0 ? 'cart-summary-empty' : ''">
            <span aria-hidden="true"><i class="glyphicon glyphicon-shopping-cart"></i></span>
            <span class="sr-only">{{ Cart.NumberOfCartItems }} item(s) in cart</span>
            <span id="summary-NumberOfItems" class="NumberOfItems" v-show="Cart.NumberOfCartItems != undefined && Cart.NumberOfCartItems > 0">{{ Cart.NumberOfCartItems }}</span>
            <span class="NumberOfItems ZeroItems" v-show="Cart.NumberOfCartItems == undefined || Cart.NumberOfCartItems == 0">0</span>
            <span id="summary-total" class="hidden-xs">{{ Cart.TotalToFormat }}</span>
            <span class="sr-only">{{getInterfaceText('cart_total_amount')}} {{ Cart.TotalToFormat }}</span>
        </a>

        <div class="summary-popup dialog" v-show="isCartSummaryOpen && Cart.CartItems && Cart.CartItems.length > 0" style="display:none;" role="dialog" aria-modal="true" aria-label="Cart">
            <div id="overlay" style="width: 100%; height: 100%; position: inherit; top: 0; left: 0; background: rgba(0, 0, 0, 0.3); z-index: 99;" v-show="CartInProgress == true">
                <div class="lds-dual-ring" style="min-height:100%"></div>
            </div>
            <div class="row close-button">
                <div class="col-md-12 text-right">
                    <button v-on:click="isCartSummaryOpen = false" id="cartCloseButton" aria-label="close" class="btn-close"><i class="glyphicon glyphicon-remove"></i></button>
                </div>
            </div>
            <div class="body">
                <div v-show="Cart.LockedCart == false">
                    <CartTable :edit-mode="true" :summary-mode="true"></CartTable>
                </div>
                <div v-show="Cart.LockedCart == true" v-html="Cart.LockedCartDescription"></div>
            </div>
            <div class="row" style="padding-top: 15px;" v-show="!Cart.LockedCart">
                <div class="col-md-12 text-right">
                    <button id="proceedToCheckoutButton" v-on:click="redirectToCart" class="btn btn-proceed btn-enable-progress">{{getInterfaceText('shop_proceedtocheckout')}} <i class="glyphicon glyphicon-menu-right hidden-xs" aria-hidden="true"></i></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import cartMixin from '../../mixins/cart-mixin.js';
    import generalMixin from '../../mixins/general.js';
    import CartTable from '@/components/CartTable.vue';
    export default {
        name: 'CartSummary',
        mixins: [cartMixin, generalMixin],
        components: {
            CartTable
        },
        data: function () {
            return {
                isCartSummaryOpen: false,
                loading: true,
                culture: window.culture
            }
        },
        beforeMount() {
            this.getCartSummary(false);
        },
        methods: {
            redirectToCart: function () {
                window.location = '/' + this.culture + '/shop/review';
            },
            openModal: function () {
                this.isCartSummaryOpen = !this.isCartSummaryOpen;
                if (this.isCartSummaryOpen) {
                    setTimeout(function () { document.getElementById('cartCloseButton').focus(); }, 100);

                    //GA4
                    var items = [];
                    for (var i = 0; i < this.Cart.CartItems.length; i++) {
                        items.push({
                            'item_id': (this.Cart.CartItems[i].Product.ProductTypeId == 1 ? 'bikemodel-' : 'gearproduct-') + this.Cart.CartItems[i].Product.Id.toString(),
                            'item_name': this.Cart.CartItems[i].Product.Name.toLowerCase(),
                            'discount': this.Cart.CartItems[i].Product.PriceOriginal > 0 ? this.Cart.CartItems[i].Product.PriceOriginal - this.Cart.CartItems[i].Product.Partnumber._price : 0,
                            'index': 1,
                            'item_brand': this.Cart.CartItems[i].Product.BrandName.toLowerCase(),
                            'item_category': this.Cart.CartItems[i].Product.PageCategories != undefined && this.Cart.CartItems[i].Product.PageCategories.length > 0 ? this.Cart.CartItems[i].Product.PageCategories[0].GA_label.toLowerCase() : 'n/a',
                            'item_category2': this.Cart.CartItems[i].Product.PageCategories != undefined && this.Cart.CartItems[i].Product.PageCategories.length > 1 ? this.Cart.CartItems[i].Product.PageCategories[1].GA_label.toLowerCase() : 'n/a',
                            'item_category3': this.Cart.CartItems[i].Product.PageCategories != undefined && this.Cart.CartItems[i].Product.PageCategories.length > 2 ? this.Cart.CartItems[i].Product.PageCategories[2].GA_label.toLowerCase() : 'n/a',
                            /*'item_list_name': this.Cart.CartItems[i].Product.GA_Category,*/
                            'item_variant': (this.Cart.CartItems[i].Product.Partnumber.Size + (this.Cart.CartItems[i].Product.Partnumber.Color != undefined && this.Cart.CartItems[i].Product.Partnumber.Color.length > 0 ? ' ' + this.Cart.CartItems[i].Product.Partnumber.Color : '')).toLowerCase(),
                            'price': this.Cart.CartItems[i].Product.PriceOriginal,
                            'quantity': this.Cart.CartItems[i].Quantity
                        });
                    }
                    window.trackEventGlobalAndLocalGA4({
                        'ga4_name': 'view_cart',
                        'ga4_currency': window.currencyCode,
                        'ga4_value': this.Cart.TotalIncludingShippingCosts,
                        'ga4_items': items
                    });
                }
            }
        },
        computed: {
            // See cartMixin
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-cart-parameters').dataset.interfacetexts);
        }
    }
</script>
